var cov_d0k54pd9k = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/locale/index.ts",
      hash = "ee2ec36cff7a1dab322164020afc8ed8608d2c46",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/locale/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 8,
          column: 25
        },
        end: {
          line: 8,
          column: 60
        }
      },
      "1": {
        start: {
          line: 11,
          column: 2
        },
        end: {
          line: 15,
          column: 3
        }
      },
      "2": {
        start: {
          line: 12,
          column: 4
        },
        end: {
          line: 12,
          column: 38
        }
      },
      "3": {
        start: {
          line: 13,
          column: 9
        },
        end: {
          line: 15,
          column: 3
        }
      },
      "4": {
        start: {
          line: 14,
          column: 4
        },
        end: {
          line: 14,
          column: 52
        }
      },
      "5": {
        start: {
          line: 19,
          column: 2
        },
        end: {
          line: 19,
          column: 26
        }
      },
      "6": {
        start: {
          line: 19,
          column: 13
        },
        end: {
          line: 19,
          column: 26
        }
      },
      "7": {
        start: {
          line: 20,
          column: 2
        },
        end: {
          line: 20,
          column: 40
        }
      },
      "8": {
        start: {
          line: 20,
          column: 24
        },
        end: {
          line: 20,
          column: 40
        }
      },
      "9": {
        start: {
          line: 21,
          column: 2
        },
        end: {
          line: 21,
          column: 30
        }
      }
    },
    fnMap: {
      "0": {
        name: "setLocale",
        decl: {
          start: {
            line: 10,
            column: 16
          },
          end: {
            line: 10,
            column: 25
          }
        },
        loc: {
          start: {
            line: 10,
            column: 53
          },
          end: {
            line: 16,
            column: 1
          }
        },
        line: 10
      },
      "1": {
        name: "getLocale",
        decl: {
          start: {
            line: 18,
            column: 16
          },
          end: {
            line: 18,
            column: 25
          }
        },
        loc: {
          start: {
            line: 18,
            column: 59
          },
          end: {
            line: 22,
            column: 1
          }
        },
        line: 18
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 8,
            column: 25
          },
          end: {
            line: 8,
            column: 60
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 8,
            column: 53
          },
          end: {
            line: 8,
            column: 55
          }
        }, {
          start: {
            line: 8,
            column: 58
          },
          end: {
            line: 8,
            column: 60
          }
        }],
        line: 8
      },
      "1": {
        loc: {
          start: {
            line: 11,
            column: 2
          },
          end: {
            line: 15,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 11,
            column: 2
          },
          end: {
            line: 15,
            column: 3
          }
        }, {
          start: {
            line: 11,
            column: 2
          },
          end: {
            line: 15,
            column: 3
          }
        }],
        line: 11
      },
      "2": {
        loc: {
          start: {
            line: 12,
            column: 13
          },
          end: {
            line: 12,
            column: 38
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 12,
            column: 31
          },
          end: {
            line: 12,
            column: 33
          }
        }, {
          start: {
            line: 12,
            column: 36
          },
          end: {
            line: 12,
            column: 38
          }
        }],
        line: 12
      },
      "3": {
        loc: {
          start: {
            line: 13,
            column: 9
          },
          end: {
            line: 15,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 13,
            column: 9
          },
          end: {
            line: 15,
            column: 3
          }
        }, {
          start: {
            line: 13,
            column: 9
          },
          end: {
            line: 15,
            column: 3
          }
        }],
        line: 13
      },
      "4": {
        loc: {
          start: {
            line: 19,
            column: 2
          },
          end: {
            line: 19,
            column: 26
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 19,
            column: 2
          },
          end: {
            line: 19,
            column: 26
          }
        }, {
          start: {
            line: 19,
            column: 2
          },
          end: {
            line: 19,
            column: 26
          }
        }],
        line: 19
      },
      "5": {
        loc: {
          start: {
            line: 20,
            column: 2
          },
          end: {
            line: 20,
            column: 40
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 20,
            column: 2
          },
          end: {
            line: 20,
            column: 40
          }
        }, {
          start: {
            line: 20,
            column: 2
          },
          end: {
            line: 20,
            column: 40
          }
        }],
        line: 20
      },
      "6": {
        loc: {
          start: {
            line: 20,
            column: 6
          },
          end: {
            line: 20,
            column: 22
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 20,
            column: 6
          },
          end: {
            line: 20,
            column: 9
          }
        }, {
          start: {
            line: 20,
            column: 13
          },
          end: {
            line: 20,
            column: 22
          }
        }],
        line: 20
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import { deepMerge, deepGet } from '../utils/objects';
import config from '../config';
import cn from './zh-CN';
import en from './en_US';
var locale = (cov_d0k54pd9k.s[0]++, config.locale === 'zh-CN' ? (cov_d0k54pd9k.b[0][0]++, cn) : (cov_d0k54pd9k.b[0][1]++, en));
export function setLocale(arg) {
  cov_d0k54pd9k.f[0]++;
  cov_d0k54pd9k.s[1]++;

  if (typeof arg === 'string') {
    cov_d0k54pd9k.b[1][0]++;
    cov_d0k54pd9k.s[2]++;
    locale = arg === 'zh-CN' ? (cov_d0k54pd9k.b[2][0]++, cn) : (cov_d0k54pd9k.b[2][1]++, en);
  } else {
    cov_d0k54pd9k.b[1][1]++;
    cov_d0k54pd9k.s[3]++;

    if (typeof arg === 'object') {
      cov_d0k54pd9k.b[3][0]++;
      cov_d0k54pd9k.s[4]++;
      locale = deepMerge(locale, arg, {
        clone: true
      });
    } else {
      cov_d0k54pd9k.b[3][1]++;
    }
  }
}
export function getLocale(name, def) {
  cov_d0k54pd9k.f[1]++;
  cov_d0k54pd9k.s[5]++;

  if (!name) {
    cov_d0k54pd9k.b[4][0]++;
    cov_d0k54pd9k.s[6]++;
    return locale;
  } else {
    cov_d0k54pd9k.b[4][1]++;
  }

  cov_d0k54pd9k.s[7]++;

  if ((cov_d0k54pd9k.b[6][0]++, def) && (cov_d0k54pd9k.b[6][1]++, def[name])) {
    cov_d0k54pd9k.b[5][0]++;
    cov_d0k54pd9k.s[8]++;
    return def[name];
  } else {
    cov_d0k54pd9k.b[5][1]++;
  }

  cov_d0k54pd9k.s[9]++;
  return deepGet(locale, name);
}